
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 13a6 6 0 116-6 6 6 0 01-6 6zm0-11a5 5 0 105 5 5 5 0 00-5-5zM7 20a4 4 0 114-4 4 4 0 01-4 4zm0-7a3 3 0 103 3 3 3 0 00-3-3zm13 9a3 3 0 113-3 3 3 0 01-3 3zm0-5a2 2 0 102 2 2 2 0 00-2-2zM.5 24a.5.5 0 01-.5-.5V.5a.5.5 0 011 0v23a.5.5 0 01-.5.5z"}}),_c('path',{attrs:{"d":"M23.5 24H.5a.5.5 0 010-1h23a.5.5 0 010 1z"}})])
          )
        }
      }
    